module.exports = __webpack_public_path__ + "img/programme-3.318bbd6c.png";